import { useState } from 'react'
import { Box, ColorOptions, MaterialTextInput, TextInputNew } from '@jfs/ui-new'
import { TextInput } from 'react-native'
import { convertHexToRGBA } from '../../utils'
import { creditCardStyles } from './styles'

interface CardHolderNameInputProps {
  innerRef?: React.RefObject<TextInput>
  prevRef?: React.RefObject<TextInput>
  isValidCardHolder: (value: boolean) => void
  cardHolderName: string
  setCardHolderName: (value: string) => void
  theme?: any
  addlFotterComp?: React.ReactNode
  isMaterialInput?: boolean
}

const CardHolderNameInput = ({
  innerRef,
  prevRef,
  isValidCardHolder,
  cardHolderName,
  setCardHolderName,
  theme,
  addlFotterComp,
  isMaterialInput = true,
}: CardHolderNameInputProps) => {
  const [errorMsg, setErrorMsg] = useState('')
  const styles = creditCardStyles(theme)
  const internalOnChangeCardHolder = (text: string) => {
    errorMsg && setErrorMsg('')
    const formattedCardHolderName = text.replace(/[^a-zA-Z ]/g, '')
    if (formattedCardHolderName.length) {
      isValidCardHolder(true)
    } else {
      isValidCardHolder(false)
    }
    setCardHolderName(formattedCardHolderName)
  }

  const internalOnCardHolderPress = ({ nativeEvent }: { nativeEvent: any }) => {
    if (nativeEvent?.key === 'Backspace' && !cardHolderName.length) {
      prevRef?.current?.focus()
    }
  }

  const onInternalBlur = () => {
    try {
      if (!cardHolderName.length) {
        throw new Error()
      }
    } catch (error) {
      setErrorMsg('Invalid cardholder name')
      isValidCardHolder(false)
    }
  }

  return (
    <>
      <Box {...styles.cardHolderContainer}>
        {isMaterialInput && (
          <MaterialTextInput
            innerRef={innerRef}
            onKeyPress={internalOnCardHolderPress}
            maxLength={35}
            value={cardHolderName}
            onChangeText={(text: string) => internalOnChangeCardHolder(text)}
            placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
            onBlur={onInternalBlur}
            placeholder={'Cardholder Name'}
            keyboardType={'name-phone-pad'}
            error={errorMsg}
            testID={'cardHolderName'}
            color={theme?.bodyTextColor}
            bottomLineColor={theme?.brandColor as ColorOptions}
            tintColor={theme?.brandColor as ColorOptions}
          />
        )}
      </Box>
      {!isMaterialInput && (
        <TextInputNew
          innerRef={innerRef}
          onKeyPress={internalOnCardHolderPress}
          maxLength={35}
          value={cardHolderName}
          onChangeText={(text: string) => internalOnChangeCardHolder(text)}
          placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 40) as ColorOptions}
          fontSize={12}
          onBlur={onInternalBlur}
          placeholder={'Cardholder Name'}
          keyboardType={'name-phone-pad'}
          error={errorMsg}
          testID={'cardHolderName'}
          color={theme?.bodyTextColor}
          showBottomLine={false}
          borderColor={convertHexToRGBA(theme?.brandColor, 40) as ColorOptions}
          focusBorderColor={convertHexToRGBA(theme?.brandColor, 40) as ColorOptions}
          borderRadius={8}
          paddingHorizontal={8}
          paddingVertical={14}
          type={'body10'}
        />
      )}
      {addlFotterComp ? addlFotterComp : undefined}
    </>
  )
}

export { CardHolderNameInput }
